import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBucket: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBucket"><Path d="M2.5 3C2.22386 3 2 3.22386 2 3.5V7.5C2 7.77614 2.22386 8 2.5 8H21.5C21.7761 8 22 7.77614 22 7.5V3.5C22 3.22386 21.7761 3 21.5 3H2.5Z" fill="currentColor"/><Path d="M3.7964 9L4.81555 18.7596C4.94851 20.0329 6.02184 21 7.30203 21H16.698C17.9782 21 19.0515 20.0329 19.1845 18.7597L20.2037 9H3.7964Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBucket;
